export default __webpack_public_path__ + "static/media/card_3.48c0ce04.jpg";